import React from "react";
import { Box } from "@mui/material";
import Footer from "./Footer";
import Navbar from "./Navbar";

export default function Layout({ children }) {
  return (
    <Box>
      <Navbar />

      {/* Main Content */}
      <Box component="main" sx={{ minHeight: "80vh", pt: 3 }}>
        {children}
      </Box>

      <Footer />
    </Box>
  );
}
